/* istanbul ignore file */
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpSimplifiedErrorResponse } from '../interfaces/http-simplified-error-response';

export function LoggableObservable(): MethodDecorator {
  return (target: any, key: string, descriptor: any) => {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]): any {
      return originalMethod.apply(this, args).pipe(
        catchError((errorResponse) => {
          console.log(`${target.constructor.name} class`);
          console.log(`${key} method`);
          console.log('An error occurred: %o', errorResponse);
          const httpSimplifiedErrorResponse: HttpSimplifiedErrorResponse = {
            errorMessage:
              errorResponse.error?.customErrorMessage ?? errorResponse.error,
            status: errorResponse.status,
          };
          return throwError(httpSimplifiedErrorResponse);
        }),
      );
    };
    return descriptor;
  };
}
